<template>
  <div class="cart-card">

    <!-- Period groups -->
    <div class="period-group" v-for="period in periods" v-bind:key="period.id">
      <div class="period-group-header">
        <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
        {{ period.title }}
      </div>

      <div class="cart-items">
        <div
          class="cart-item"
          v-for="(item, index) in cart"
          v-bind:key="index"
          v-if="item.period_id == period.id"
        >
          <div class="cart-item-body">
            <span class="cart-item-name">
              <span class="cart-item-qty" v-if="showqty">{{ item.quantity }}×</span>
              {{ item.label }}
            </span>
            <div class="cart-item-tags" v-if="itemTags(item).length">
              <span class="cart-tag" v-for="(tag, i) in itemTags(item)" :key="i">{{ tag }}</span>
            </div>
            <span class="cart-item-price" v-if="free_issue">R{{ item.price }}</span>
          </div>
          <button
            v-if="showDelete == 'true'"
            class="remove-btn"
            type="button"
            @click="removeItem(item, index)"
            title="Remove"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
          </button>
        </div>
      </div>
    </div>

    <!-- Notes -->
    <div class="notes-section" v-if="showNotes == 'true'">
      <label class="notes-label">
        <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>
        Delivery Notes
      </label>
      <textarea class="notes-textarea" v-model="notes" rows="3" placeholder="Any special instructions…"></textarea>
    </div>

    <!-- Signature pad -->
    <div class="signature-section" v-if="show_sign == 'Y' && showCheckout == 'false'">
      <div class="signature-header">
        <label class="notes-label">
          <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M12 20h9"/><path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"/></svg>
          Patient Signature
        </label>
        <span class="signature-optional-badge">Optional</span>
      </div>
      <p class="signature-hint">Ask the patient to sign in the box below to confirm their meal selection.</p>
      <div id="signature-pad" class="signature-pad-wrap">
        <div class="signature-placeholder-text">Sign here</div>
        <canvas id="canvasSignature" crossorigin="anonymous"></canvas>
        <form action="https://sigplusweb.com/sign_chrome_ff_sigplusextlite.html#" name="FORM1">
          <input type="HIDDEN" name="bioSigData">
          <input type="HIDDEN" name="sigImgData">
          <input type="hidden" name="sigStringData">
          <input type="hidden" name="sigRawData">
        </form>
      </div>
      <img crossOrigin="Anonymous" src="" id="FuneralProductSign_SignDisplay" style="display:none;width:100%;" />
      <button @click="ClearSign" type="button" class="clear-sign-btn">
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="1 4 1 10 7 10"/><path d="M3.51 15a9 9 0 1 0 .49-3.3"/></svg>
        Clear Signature
      </button>
    </div>

    <!-- Actions -->
    <div class="cart-actions">
      <button type="button" class="action-btn action-btn--primary" v-on:click="initPlaceOrder" v-if="showCheckout == 'false'">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
        Submit Order
      </button>
      <router-link to="/checkout" v-if="showCheckout == 'true'" class="action-btn action-btn--save">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"/><polyline points="17 21 17 13 7 13 7 21"/><polyline points="7 3 7 8 15 8"/></svg>
        Save &amp; Review
      </router-link>
      <slot name="extra-action"></slot>
    </div>

    <!-- Order success modal -->
    <div id="orderModal" class="modal fade" role="dialog">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content order-modal">

          <div class="order-modal-header">
            <div class="order-success-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
            </div>
            <h2 class="order-modal-title">Order Placed!</h2>
            <p class="order-modal-sub">Order #<strong>{{ order_id }}</strong></p>
          </div>

          <div class="order-modal-body" v-if="enable_print_from_device === 'Y'">
            <p class="printer-section-label">Printer Settings</p>

            <div class="printer-field">
              <label class="printer-label">Printer Type</label>
              <div class="select-wrap">
                <select v-model="printer_type">
                  <option value="">Select Printer</option>
                  <option v-for="p in printers" v-bind:key="p" v-bind:value="p">{{ p }}</option>
                </select>
                <svg class="select-arrow" xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"/></svg>
              </div>
            </div>

            <div class="printer-field">
              <label class="printer-label">IP Address</label>
              <input type="text" class="printer-input" placeholder="192.168.1.100" v-model="ip_address">
            </div>

            <div class="printer-row">
              <div class="printer-field">
                <label class="printer-label">Port</label>
                <input maxlength="4" type="number" class="printer-input" placeholder="9100" v-model="port">
              </div>
              <div class="printer-field">
                <label class="printer-label">Paper Size</label>
                <input type="text" class="printer-input" placeholder="57" v-model="paper_size">
              </div>
            </div>
          </div>

          <div class="order-modal-footer">
            <button type="button" class="modal-btn modal-btn--print" v-on:click="print_slip()" v-if="enable_print_from_device === 'Y'">
              <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 6 2 18 2 18 9"/><path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"/><rect x="6" y="14" width="12" height="8"/></svg>
              Print Slip
            </button>
            <button type="button" class="modal-btn modal-btn--done" data-dismiss="modal" v-on:click="done()">
              Done
            </button>
          </div>

        </div>
      </div>
    </div>

  </div>
</template>

<script>
import swal from 'sweetalert'

export default {
  name: 'cart',
  props: ['showDelete', 'showQuantity', 'showCheckout', 'showNotes'],
  data: function () {
    return {
      cart: window.localStorage.getItem('cart') ? JSON.parse(window.localStorage.getItem('cart')) : [],
      cartBalance: 0,
      balance: this.calculateBalance(),
      notes: '',
      signature: '',
      periods: [],
      show_sign: this.showSign(),
      showqty: this.showHideQty(),
      printer_type: '',
      ip_address: '',
      port: 9100,
      paper_size: 57,
      order_id: '',
      print_items: [],
      free_issue: false,
      enable_print_from_device: (function () { try { return JSON.parse(window.localStorage.getItem('user')).merchant.enable_print_from_device } catch (e) { return 'N' } }()),
      printers: ['bluetooth', 'network', 'usb']
    }
  },
  mounted: function () {
    var that = this

    if (window.localStorage.getItem('free_issue') === 'Y') {
      this.free_issue = true
    }

    if (window.localStorage.getItem('printer_type')) that.printer_type = window.localStorage.getItem('printer_type')
    if (window.localStorage.getItem('ip_address'))   that.ip_address   = window.localStorage.getItem('ip_address')
    if (window.localStorage.getItem('port'))         that.port         = window.localStorage.getItem('port')
    if (window.localStorage.getItem('paper_size'))   that.paper_size   = window.localStorage.getItem('paper_size')

    this.showSign()
    this.$store.commit('SET_LAYOUT', 'AppLayout')

    var periods = []
    this.cart.forEach(function (item) {
      periods.push({ title: item.period_title, id: item.period_id })
    })

    var obj = {}
    periods.forEach(function (p) { obj[p.id] = p })
    this.periods = Object.values(obj)

    StartSign()
    window.setTimeout(function () {
      var wrapper = document.getElementById('signature-pad')
      if (wrapper) {
        var canvas = wrapper.querySelector('canvas')
        SigningCanvas = new SignaturePad(canvas, { backgroundColor: 'rgb(255,255,255)' })
      }
    }, 800)
  },
  methods: {
    itemTags: function (item) {
      var tags = []
      if (item.additions) item.additions.forEach(function (a) { tags.push(a.label) })
      if (item.exclusions) item.exclusions.forEach(function (e) { tags.push('No ' + e.label) })
      return tags
    },
    showHideQty: function () {
      var user = JSON.parse(window.localStorage.getItem('user'))
      return user.merchant.show_order_item_quantities === 'Y'
    },
    ClearSign: function () {
      SigningCanvas.clear()
      StartSign()
    },
    showSign: function () {
      var user = JSON.parse(window.localStorage.getItem('user'))
      return user.merchant.show_signature
    },
    calculateBalance: function () {
      var user = JSON.parse(window.localStorage.getItem('user'))
      return user.wallet_balance
    },
    removeItem: function (item, index) {
      var newCart = this.cart.filter(function (c, i) { return i !== index })
      if (newCart.length === 0) { window.history.back() }
      this.cart = newCart
      window.localStorage.setItem('cart', JSON.stringify(newCart))
    },
    guid: function () {
      function s4 () { return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1) }
      return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4()
    },
    initPlaceOrder: function () {
      var that = this
      window.localStorage.setItem('notes', that.notes)
      if (window.localStorage.getItem('free_issue') === 'Y') {
        var Base64ImgTmp = ''
        if (this.show_sign === 'Y') {
          var wrapper = document.getElementById('signature-pad')
          var canvas = wrapper.querySelector('canvas')
          Base64ImgTmp = canvas.toDataURL('image/jpeg').replace(/^data:image\/(png|jpg|jpeg);base64,/, '')
        }
        window.localStorage.setItem('Base64ImgTmp', Base64ImgTmp)
        that.$router.push('/freeissueorder')
      } else {
        that.placeOrder()
      }
    },
    placeOrder: function () {
      $.showLoading()
      var that = this
      var user = JSON.parse(window.localStorage.getItem('user'))
      var merchantId = user.merchant.id
      var period = JSON.parse(window.localStorage.getItem('period'))
      var date = window.localStorage.getItem('date')
      var bed = JSON.parse(window.localStorage.getItem('bed'))

      var items = []
      this.cart.forEach(function (item) {
        items.push({ menu_id: item.mealId, price: item.price, additions: item.additions, exclusions: item.exclusions, period_id: item.period_id, quantity: item.quantity })
      })
      this.print_items = this.cart

      var Base64ImgTmp = ''
      if (this.show_sign === 'Y') {
        var wrapper = document.getElementById('signature-pad')
        var canvas = wrapper.querySelector('canvas')
        Base64ImgTmp = canvas.toDataURL('image/jpeg').replace(/^data:image\/(png|jpg|jpeg);base64,/, '')
      }

      var data = { period_id: period.id, date: date, note: that.notes, items: items, merchant_id: merchantId, bed_id: bed.bed_id, token: localStorage.getItem('token'), signature: Base64ImgTmp }

      $.ajax({
        url: this.$config.apiUrl + 'canteenapp_orders/place',
        type: 'POST',
        data: data,
        success: function (data) {
          $.hideLoading()
          window.localStorage.removeItem('cart')
          that.order_id = data.data.order.id
          that.notes = data.data.order.note
          $('#orderModal').modal('show')
        },
        error: function () {
          swal('Error', 'Your order has timed out. Please check your connection and try again.', 'error')
          $.hideLoading()
        },
        timeout: 60000
      })
    },
    done: function () {
      var date = window.localStorage.getItem('date')
      var bed = JSON.parse(window.localStorage.getItem('bed'))
      this.$router.push('/preorder/' + bed.ward_id + '/' + bed.bed_id + '/' + date)
    },
    print_slip: function () {
      var that = this
      var bed = JSON.parse(window.localStorage.getItem('bed'))
      window.localStorage.setItem('printer_type', that.printer_type)
      window.localStorage.setItem('ip_address', that.ip_address)
      window.localStorage.setItem('port', that.port)
      window.localStorage.setItem('paper_size', that.paper_size)

      if (!that.printer_type) { alertify.error('No printer settings found.'); return false }

      var user = JSON.parse(window.localStorage.getItem('user'))
      var itemsHtml = ''
      var item_counter = 0
      for (var i = 0; i < that.print_items.length; i++) {
        item_counter++
        var additions = that.print_items[i].additions
        var additions_span = []
        for (var a = 0; a < additions.length; a++) { additions_span.push(additions[a].label) }
        if (that.showqty) {
          itemsHtml += item_counter + '. ' + that.print_items[i].quantity + 'x ' + that.print_items[i].label + ' '
        } else {
          itemsHtml += item_counter + '. ' + that.print_items[i].label + ' '
        }
        if (additions.length > 0) { itemsHtml += '(' + additions_span.join(', ') + ')\n' }
      }

      if (that.printer_type === 'network') {
        String.prototype.centerText = function (n) {
          var t = this.trim(), l = t.length, w2 = Math.floor(n / 2), l2 = Math.floor(l / 2)
          var s = new Array(w2 - l2 + 1).join(' ')
          t = s + t + s
          if (t.length < n) t += new Array(n - t.length + 1).join(' ')
          return t
        }
        var esc = '\x1B', newLine = '\x0A'
        var billSpanMerchant = esc + '!' + '\x38' + user.merchant.name + newLine + esc + '!' + '\x00'
        var billSpan = 'Hostess: ' + user.name + '\n' + 'Ward:    ' + bed.ward_name + '\n' + 'Bed:     ' + bed.bed_code + '\n' + 'Date:    ' + window.localStorage.getItem('date') + '\n\n' + 'Note:  ' + that.notes + '\n\n' + itemsHtml + '\n\n'
        var fullPrint = billSpanMerchant.centerText(38).toUpperCase() + '\n' + ('Order #' + that.order_id).centerText(45).toUpperCase() + '\n\n' + billSpan + '\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n' + '\x1b' + '\x69'
        var socket = new Socket()
        socket.open(that.ip_address, Number(that.port), function () {
          var data = new Uint8Array(fullPrint.length)
          for (var i = 0; i < data.length; i++) { data[i] = fullPrint.charCodeAt(i) }
          socket.write(data)
          socket.close()
        }, function (err) { alertify.error(err) })
      }

      if (that.printer_type === 'bluetooth') {
        var billSpan2 = 'Hostess: ' + user.name + '\n' + 'Ward:    ' + bed.ward_name + '\n' + 'Bed:     ' + bed.bed_code + '\n' + 'Date:    ' + window.localStorage.getItem('date') + '\n\n' + 'Note:  ' + that.notes + '\n\n' + itemsHtml + '\n\n'
        BTPrinter.list(function (data) {
          BTPrinter.disconnect(function () {}, function () {}, data[0])
          setTimeout(function () {
            BTPrinter.connect(function () {
              BTPrinter.setEncoding(function () {}, function () {}, 'ISO-8859-1')
              BTPrinter.printTitle(function () {}, function () {}, user.merchant.name.toUpperCase(), '30', '1')
              BTPrinter.printTitle(function () {}, function () {}, '\nOrder #' + that.order_id + '\n', '9', '1')
              BTPrinter.printTextSizeAlign(function () {}, function () {}, billSpan2 + '\n\n' + '\x1b' + '\x69', '8', '0')
            }, function (err) { alertify.error(err) }, data[0])
          }, 1500)
        }, function (err) { alertify.error(err) })
      }

      if (that.printer_type === 'usb') {
        var fullPrint2 = "<div style='text-align:center;font-size:30px'>" + user.merchant.name + "</div><div style='text-align:center'>Order #" + that.order_id + "</div><br>" + 'Date: ' + window.localStorage.getItem('date') + '<br>Host: ' + user.name + '<br>Note: ' + that.notes + '<br><br>' + itemsHtml
        if (cordova.platformId === 'browser') { var w = window.open(); w.document.write(fullPrint2); w.print(); w.close() }
        else { cordova.plugins.printer.print(fullPrint2) }
      }
    },
    itemInstructions: function (item) {
      var output = this.showqty ? '<strong>' + item.quantity + ' x ' + item.label + '</strong>' : '<strong>' + item.label + '</strong>'
      var additions = []
      if (item.additions) item.additions.forEach(function (a) { additions.push(a.label) })
      if (item.exclusions) item.exclusions.forEach(function (e) { additions.push(e.label) })
      if (additions.length > 0) output += '<br/><span class="item-description">' + additions.join(', ') + '</span>'
      return output
    }
  }
}
</script>

<style scoped>
.cart-card {
  background: #fff;
  border-radius: 16px;
  overflow: clip; /* clip preserves border-radius without blocking position:sticky on children */
  /* border: 2px solid #124564; */
  box-shadow: 0 -3px 8px rgba(18,69,100,0.18), 0 5px 14px rgba(18,69,100,0.22);
}

/* ── Period group ── */
.period-group {
  border-bottom: 1px solid #f1f5f9;
}
.period-group:last-of-type { border-bottom: none; }

.period-group-header {
  display: flex;
  align-items: center;
  gap: 7px;
  padding: 12px 16px 8px;
  font-size: 0.7rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 1.2px;
  color: #1a587b;
  background: #f0f9ff;
}

.cart-items { padding: 4px 0; }

/* ── Cart item row ── */
.cart-item {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 11px 16px;
  border-bottom: 1px solid #f8fafc;
  transition: background 0.12s;
}
.cart-item:last-child { border-bottom: none; }
.cart-item:hover { background: #f8fafc; }

.cart-item-body {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 5px;
  min-width: 0;
}

.cart-item-name {
  font-size: 0.875rem;
  font-weight: 600;
  color: #0f172a;
  line-height: 1.3;
}

.cart-item-qty {
  color: #1a587b;
  margin-right: 4px;
}

.cart-item-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
}

.cart-tag {
  font-size: 0.65rem;
  font-weight: 600;
  color: #475569;
  background: #f1f5f9;
  padding: 2px 7px;
  border-radius: 999px;
  box-shadow: 0 -2px 5px rgba(18,69,100,0.15), 0 3px 7px rgba(18,69,100,0.18);
}

.cart-item-price {
  font-size: 0.78rem;
  font-weight: 700;
  color: #1a587b;
}

.remove-btn {
  width: 26px;
  height: 26px;
  border-radius: 7px;
  border: none;
  background: #fee2e2;
  color: #ef4444;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  flex-shrink: 0;
  transition: background 0.15s;
  margin-top: 2px;
}
.remove-btn:hover { background: #fecaca; }

/* ── Notes ── */
.notes-section {
  padding: 14px 16px;
  border-top: 1px solid #f1f5f9;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.notes-label {
  font-size: 0.72rem;
  font-weight: 700;
  color: #475569;
  display: flex;
  align-items: center;
  gap: 6px;
  margin: 0;
}

.notes-textarea {
  width: 100%;
  padding: 10px 12px;
  border: 1.5px solid #e2e8f0;
  border-radius: 10px;
  font-size: 0.875rem;
  color: #0f172a;
  background: #f8fafc;
  resize: none;
  outline: none;
  box-sizing: border-box;
  font-family: inherit;
  transition: border-color 0.15s, box-shadow 0.15s;
}
.notes-textarea:focus { border-color: #1a587b; box-shadow: 0 0 0 3px rgba(26,88,123,0.1); background: #fff; }
.notes-textarea::placeholder { color: #b0bcc8; }

/* ── Signature ── */
.signature-section {
  padding: 14px 16px;
  border-top: 1px solid #f1f5f9;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.signature-header {
  display: flex;
  align-items: center;
  gap: 10px;
}

.signature-optional-badge {
  font-size: 0.68rem;
  font-weight: 700;
  color: #64748b;
  background: #f1f5f9;
  border: 1px solid #e2e8f0;
  padding: 2px 8px;
  border-radius: 999px;
  letter-spacing: 0.3px;
}

.signature-hint {
  font-size: 0.8rem;
  color: #64748b;
  margin: 0;
  line-height: 1.45;
  padding: 8px 12px;
  background: #f8fafc;
  border-radius: 8px;
  /* border-left: 3px solid #1a587b; */
}

.signature-pad-wrap {
  position: relative;
  border: 1.5px dashed #cbd5e1;
  border-radius: 10px;
  overflow: hidden;
  background: #fafbfc;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.signature-placeholder-text {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 0.85rem;
  color: #cbd5e1;
  font-style: italic;
  pointer-events: none;
  user-select: none;
  z-index: 0;
}

.signature-pad-wrap canvas {
  width: 100%;
  max-width: 100%;
  display: block;
}

.clear-sign-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 9px 14px;
  background: #fff5f5;
  color: #dc2626;
  border: 1.5px solid #fecaca;
  border-radius: 9px;
  font-size: 0.8rem;
  font-weight: 600;
  cursor: pointer;
  align-self: flex-start;
  transition: background 0.15s;
}
.clear-sign-btn:hover { background: #fee2e2; }

/* ── Actions ── */
.cart-actions {
  padding: 14px 16px 20px;
  border-top: 1px solid #e8edf2;
  display: flex;
  flex-direction: row;
  gap: 8px;
  position: sticky;
  bottom: 0;
  background: #fff;
  box-shadow: 0 -4px 20px rgba(15, 61, 92, 0.08);
  z-index: 5;
  border-radius: 0 0 16px 16px;
}

.action-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  flex: 1;
  padding: 13px;
  border: none;
  border-radius: 11px;
  font-size: 0.9rem;
  font-weight: 700;
  cursor: pointer;
  text-decoration: none !important;
  transition: opacity 0.2s, transform 0.1s;
  letter-spacing: 0.2px;
}
.action-btn:active { transform: scale(0.98); }

.action-btn--primary {
  background: linear-gradient(135deg, #1a587b 0%, #0f3d5c 100%);
  color: #fff !important;
  box-shadow: 0 4px 14px rgba(26, 88, 123, 0.3);
}
.action-btn--primary:hover { opacity: 0.92; }

.action-btn--save {
  background: #ef5953;
  color: #fff !important;
  border: 1.5px solid #ef5953;
}
.action-btn--save:hover { background: #e04540; }

/* ── Order success modal ── */
.order-modal {
  border-radius: 16px;
  overflow: hidden;
  border: none;
}

.order-modal-header {
  background: linear-gradient(135deg, #1a587b 0%, #0f3d5c 100%);
  padding: 28px 20px 22px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}

.order-success-icon {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background: rgba(255,255,255,0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
}

.order-modal-title {
  font-size: 1.3rem;
  font-weight: 700;
  color: #fff;
  margin: 0;
}

.order-modal-sub {
  font-size: 0.875rem;
  color: rgba(255,255,255,0.75);
  margin: 0;
}

.order-modal-body {
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.printer-section-label {
  font-size: 0.68rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 1.3px;
  color: #94a3b8;
  margin: 0 0 2px;
}

.printer-field {
  display: flex;
  flex-direction: column;
  gap: 5px;
  flex: 1;
}

.printer-label {
  font-size: 0.72rem;
  font-weight: 600;
  color: #475569;
}

.printer-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
}

.select-wrap { position: relative; }
.select-wrap select {
  width: 100%;
  appearance: none;
  -webkit-appearance: none;
  padding: 10px 34px 10px 12px;
  border: 1.5px solid #e2e8f0;
  border-radius: 9px;
  font-size: 0.875rem;
  color: #0f172a;
  background: #f8fafc;
  outline: none;
}
.select-arrow {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  color: #94a3b8;
  pointer-events: none;
}

.printer-input {
  padding: 10px 12px;
  border: 1.5px solid #e2e8f0;
  border-radius: 9px;
  font-size: 0.875rem;
  color: #0f172a;
  background: #f8fafc;
  outline: none;
  width: 100%;
  box-sizing: border-box;
  transition: border-color 0.15s;
}
.printer-input:focus { border-color: #1a587b; }

.order-modal-footer {
  padding: 14px 20px 20px;
  display: flex;
  gap: 10px;
}

.modal-btn {
  flex: 1;
  padding: 12px;
  border: none;
  border-radius: 10px;
  font-size: 0.875rem;
  font-weight: 700;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  transition: opacity 0.15s;
}

.modal-btn--print {
  background: linear-gradient(135deg, #1a587b, #0f3d5c);
  color: #fff;
  box-shadow: 0 3px 10px rgba(26,88,123,0.25);
}

.modal-btn--done {
  background: #f1f5f9;
  color: #475569;
  border: 1.5px solid #e2e8f0;
}
.modal-btn--done:hover { background: #e2e8f0; }
</style>
